<template>
  <span class="ml-1">
    <a :href="url" target="_blank">
      <el-button type="text" class="mr-2" :style="buttonStyle">
        {{ linkText }}
        <i class="fas fa-external-link-alt ml-1" aria-hidden="true"></i>
      </el-button>
    </a>
  </span>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    url: {
      type: String,
      required: true
    },
    pxFontSize: {
      type: Number,
      required: false,
      default: 14
    },
    linkText: {
      type: String,
      default: "Learn more"
    }
  },
  computed: {
    buttonStyle() {
      return {
        padding: "0px 0px 2px",
        color: "#00a2ff",
        fontSize: `${this.pxFontSize}px`
      };
    }
  }
};
</script>
